// tslint:disable
import { call } from 'services/api-service'

/**
 * Vote for a question
 *
 * @method
 * @name ApiService#voteQuestion
 * @param {string} sku -
 * @param {string} originSiteKey -
 * @param {integer} id -
 * @param {object} body -
 * {
 *   up:number
 * }
 */
function voteQuestion(
  parameters: {
    sku: string
    originSiteKey?: string
    id: number
  },
  body: {
    up?: number
  }
): Promise<void> {
  return call<void>(
    'POST',
    '/{siteKey}/question/{id}/vote',
    parameters,
    ['sku', 'id'],
    ['sku', 'originSiteKey'],
    [],
    body
  )
}

export default { voteQuestion }
